export default __webpack_public_path__ + "static/media/aline-logo.7a52bff3.png";